module.exports = __webpack_public_path__ + "static/media/luchador.e5061bf0.svg";